export default __webpack_public_path__ + "static/media/empty_tags.54c2f98a.png";